import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
const vanDesgin = (Vue) => {
    Vue.use(Antd)
}
export default vanDesgin